import type { ShowImeiActionDetails } from '~/api/help-center/types/Issue.types'

import type { MachineContext } from '../Diagnosis.machine.types'

export const getIMEI = (issueAction: MachineContext['issueAction']) => {
  const issueActionDetails = issueAction?.details as ShowImeiActionDetails

  return issueActionDetails?.imei
}
